/**
 * Desktop tour overlay with spotlight and tooltip navigation
 */

import { useOnboarding } from "./use-onboarding";
import { Spotlight } from "./components/spotlight";
import { TourTooltip } from "./components/tour-tooltip";
import { DESKTOP_TOUR_STEPS } from "./tour-steps";

export const TourOverlay = () => {
  const {
    isTouring,
    currentStep,
    totalSteps,
    isMobile,
    nextStep,
    prevStep,
    skipTour,
  } = useOnboarding();

  // Don't render on mobile - use TourMobile instead
  if (isMobile || !isTouring) return null;

  const step = DESKTOP_TOUR_STEPS[currentStep];
  if (!step) return null;

  // For the complete step, use center positioning
  const isCompleteStep = step.id === "complete";

  return (
    <>
      {/* Hidden element for complete step targeting */}
      <div 
        data-tour="complete-step" 
        className="fixed top-1/2 left-1/2 w-1 h-1 pointer-events-none" 
        style={{ transform: 'translate(-50%, -50%)' }}
      />
      
      <Spotlight
        targetSelector={step.targetSelector}
        padding={step.highlightPadding ?? 8}
        isVisible={true}
        isCompleteStep={isCompleteStep}
      />
      <TourTooltip
        title={step.title}
        description={step.description}
        targetSelector={step.targetSelector}
        preferredPosition={step.tooltipPosition}
        currentStep={currentStep}
        totalSteps={totalSteps}
        onNext={nextStep}
        onBack={prevStep}
        onSkip={skipTour}
        isVisible={true}
        padding={step.highlightPadding ?? 8}
      />
    </>
  );
};

